module.exports = __webpack_public_path__ + "static/media/31.d52f96b9.jpg";